import {post, put, retire} from "$lib/api";
import {currentCustomer} from "$lib/stores/customer";
import Sleep from "$lib/utils/sleep";
import {createInfo} from "$lib/calls/timeline";

let customerUUID:string;
currentCustomer.subscribe(val => {
    if(val && typeof val.uuid !== 'undefined'){
        customerUUID = val.uuid;
    }
})

export const createAssociate = async (associate:any):Promise<any> => {
    if(typeof customerUUID === 'undefined'){
        await Sleep(1000);

    }
    return await post("/associate/" + customerUUID, associate);
}

export const removeAssociateFromProject = async (projectAssociate:any, project:any):Promise<any> => {
    const call = await retire(`/project/${project.uuid}/associate/${projectAssociate.uuid}`);
    await createInfo(project, 'Ansprechpartner entfernt', 'Das Team hat sich verkleinert.');
    return call
}

export const addAssociateToProject = async (associate:any, project:any):Promise<any> => {
    const call = await post(`/project/${project.uuid}/associate`, associate);
    await createInfo(project, 'Ansprechpartner hinzugefügt', `${associate.firstName} ${associate.lastName} ist nun Teil des Teams.`);
    return call
}

export const changeProjectAssociateStatus = async (projectAssociate:any, project:any):Promise<any> => {
    const call = await put(`/project/${project.uuid}/associate/${projectAssociate.uuid}`, projectAssociate);
    await createInfo(project, 'Rechtliche Änderung!', `Benötigte Unterschriften wurden aktualisiert.`);
    return call
}

